// import logo from "./logo.svg";
// import Button from "react-bootstrap/Button";
import React, { useEffect } from "react";

const Main = () => {
  useEffect(() => {
    // if (window.location.protocol == "http:") {
    //   console.log(
    //     "you are accessing us via " +
    //       "an insecure protocol (HTTP). " +
    //       "Redirecting you to HTTPS."
    //   );

    //   window.location.href = window.location.href.replace("http:", "https:");
    // }

    window.location.replace("https://sites.google.com/rokit.co.kr/aidregen");
  }, []);

  return <div></div>;
};
export default Main;
